import { useEffect, useState } from "react";
import { Column } from "../../../containers";
import { TextInput } from "../../../inputs";
import { ConfirmChequeProps } from "./types";
import { usePopupStore, useThemeStore } from "../../../../stores";
import { PopupBack } from "../../../../popup";
import { Button } from "../../../buttons";
import { ChequeApi } from "../../../../api";

const ConfirmChequePopup = <T extends {}>({
  back,
  id,
  cb,
}: ConfirmChequeProps<T>) => {
  const [confirmedWith, setConfirmedWith] = useState<string>("");

  const theme = useThemeStore((s) => s.theme);

  const setPopupProperties = usePopupStore((s) => s.setPopupProperties);

  useEffect(() => {
    setPopupProperties({
      style: {
        maxWidth: 500,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = (): void => {
    if (!confirmedWith) return;
    ChequeApi.confirm(id.$oid, confirmedWith)
      .then((c) => {
        if (cb) cb(c);
      })
      .catch((err) => {
        console.log(err);
        if (cb) cb(null);
      });
  };

  return (
    <Column style={{ padding: "1rem", position: "relative" }} gap={20}>
      <PopupBack Component={back.component} props={back.props} />
      <TextInput
        label="تایید شده به نام"
        value={confirmedWith}
        setValue={setConfirmedWith}
      />
      <Button
        onClick={onSubmit}
        background={theme.primary}
        color={theme.textOnprimary}
      >
        تایید
      </Button>
    </Column>
  );
};

export default ConfirmChequePopup;
